export default __webpack_public_path__ + "static/media/santa-maria.87192949.svg";